import { z } from 'zod';
import { auditFieldsShape, softDeleteShape, uuidSchema } from './primitives';

/**
 * 隨手筆記本（desktop-app.md 10.7）。
 *
 * `contentJson` 存 ProseMirror 的 doc JSON 序列化字串，不是物件：
 * 鏡像的 `notes.content_json` 是 TEXT，兩邊用同一種表示法才不會在
 * 「序列化的時機」上長出兩套規則，也省掉 structured clone 走一次深物件。
 *
 * `title` 與 `plainText` 都由 `contentJson` 導出後**一起寫入**，不是查詢時才算：
 * 全域搜尋要掃過所有筆記，每次都重走一遍 ProseMirror JSON 太慢（10.7）。
 */
export const noteSchema = z.object({
  id: uuidSchema,
  /** 自動取內文第一行；空筆記是空字串，顯示時才補「未命名筆記」。 */
  title: z.string(),
  /** 使用者指定的專屬標題；null 時沿用內文第一行。 */
  customTitle: z.string().nullable().optional(),
  /** 使用者手動排列的清單位置；null 時維持依最後修改時間排序。 */
  sortOrder: z.number().finite().nullable().optional(),
  contentJson: z.string().min(1),
  plainText: z.string(),
  ...softDeleteShape,
  ...auditFieldsShape,
});

export type Note = z.infer<typeof noteSchema>;
